
import { Image } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";

interface BagHeaderProps {
  styleNumber: string;
  alternateStyleNumber?: string;
  name: string;
  alternativeName?: string;
  mainImage?: string;
  onImageClick: (image: string) => void;
}

export const BagHeader = ({
  styleNumber,
  alternateStyleNumber,
  name,
  alternativeName,
  mainImage,
  onImageClick,
}: BagHeaderProps) => {
  const isMobile = useIsMobile();

  return (
    <div className={`relative ${isMobile ? 'flex flex-col gap-4' : ''}`}>
      {mainImage ? (
        <div className={`${isMobile ? 'w-full h-48' : 'absolute right-6 top-6 w-36 h-36'} rounded-lg overflow-hidden border-2 border-gold/20 shadow-md`}>
          <img
            src={mainImage}
            alt={`${name} main view`}
            className="w-full h-full object-cover cursor-pointer"
            onClick={() => onImageClick(mainImage)}
          />
        </div>
      ) : (
        <div className={`${isMobile ? 'w-full h-48' : 'absolute right-6 top-6 w-36 h-36'} rounded-lg border-2 border-gold/20 flex items-center justify-center bg-cream`}>
          <Image className="w-12 h-12 text-gold/50" />
        </div>
      )}
      
      <div className={isMobile ? '' : 'pr-44'}>
        <p className="text-sm uppercase tracking-wider text-gold">
          Style {styleNumber}
          {alternateStyleNumber && (
            <span className="ml-2">({alternateStyleNumber})</span>
          )}
        </p>
        <h2 className="text-3xl font-display font-medium">{name}</h2>
        {alternativeName && (
          <p className="text-sm text-muted-foreground">
            {alternativeName}
          </p>
        )}
      </div>
    </div>
  );
};
